import { motion } from "framer-motion";
import { cn } from "@/lib/cn";
import { TrendBars } from "@/components/dashboard/Charts";

// `stroke` still drives the hover glow (a raw colour); `bar` is the mini chart's
// fill, which needs a Tailwind class rather than a hex value.
const ACCENTS = {
  brand: { chip: "bg-brand-500/10 text-brand-600 dark:text-brand-300", stroke: "#6366f1", bar: "bg-brand-500" },
  emerald: { chip: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-300", stroke: "#10b981", bar: "bg-emerald-500" },
  rose: { chip: "bg-rose-500/10 text-rose-600 dark:text-rose-300", stroke: "#f43f5e", bar: "bg-rose-500" },
  amber: { chip: "bg-amber-500/10 text-amber-600 dark:text-amber-300", stroke: "#f59e0b", bar: "bg-amber-500" },
  sky: { chip: "bg-sky-500/10 text-sky-600 dark:text-sky-300", stroke: "#0ea5e9", bar: "bg-sky-500" },
};

export default function StatCard({ icon: Icon, label, value, sub, accent = "brand", delay = 0, spark, sparkTitles, sparkFormat }) {
  const a = ACCENTS[accent] || ACCENTS.brand;
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.4, ease: "easeOut" }}
      whileHover={{ y: -3 }}
      className="card group relative overflow-hidden p-5"
    >
      {/* hover glow */}
      <div
        className="pointer-events-none absolute -right-8 -top-8 h-24 w-24 rounded-full opacity-0 blur-2xl transition-opacity duration-300 group-hover:opacity-100"
        style={{ background: `${a.stroke}22` }}
      />
      <div className="relative flex items-center justify-between">
        <span className="text-sm font-medium text-slate-500 dark:text-slate-400">{label}</span>
        {Icon && (
          <span className={cn("grid h-9 w-9 place-items-center rounded-xl transition-transform duration-200 group-hover:scale-110", a.chip)}>
            <Icon size={18} />
          </span>
        )}
      </div>
      <div className="relative mt-3 font-display text-3xl font-bold text-slate-900 dark:text-white">{value}</div>
      {sub && <p className="relative mt-1 text-xs text-slate-400">{sub}</p>}
      {/* Bars, not a line. `spark` is a count PER DAY, and a line interpolates
          between those points — so a week with runs on one day rendered as a flat
          rule with a single spike, implying a ramp that never happened. */}
      {spark && spark.length > 1 && (
        <div className="relative mt-3">
          <TrendBars data={spark} titles={sparkTitles} format={sparkFormat} height={30} color={a.bar} />
        </div>
      )}
    </motion.div>
  );
}
